var React = require('react');

function Bubble (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.3"},React.createElement("path",{"fill":"#FFFFFF","d":"M21.2,36.4c-3.8,0.1-7.4-1-10.5-2.6L0,39.7l5.8-9.6c-3.1-3.2-4.9-7.3-4.9-11.9C0.9,8.1,10,0,21.2,0\n\t\ts20.4,8.2,20.4,18.2c0,7.3-4.6,13.9-11.6,16.5C27.8,35.4,24.9,36.3,21.2,36.4z"})));
}

Bubble.defaultProps = {"version":"1.1","baseProfile":"basic","id":"Ebene_1","x":"0px","y":"0px","viewBox":"0 0 41.6 39.7","xmlSpace":"preserve"};

module.exports = Bubble;

Bubble.default = Bubble;
